import { createIcon } from '@chakra-ui/icons';

// hugeicons "clock-05" — the Waitlist stat tile (Workshops Figma 1943:15547).
export const Clock05 = createIcon({
  displayName: 'Clock05',
  viewBox: '0 0 24 24',
  path: (
    <g transform="translate(1 1)">
      <path fill="none" d="M11 21C5.47711 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C15.4776 1 19.2257 3.94289 20.5 8H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M11 7V11L13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M20.955 12C20.9848 11.6709 21 11.3373 21 11M14 21C14.3416 20.8876 14.6753 20.7564 15 20.6078M19.7906 16C19.9834 15.6284 20.1554 15.2433 20.305 14.8462M17.1924 19.2292C17.5369 18.9441 17.8631 18.6358 18.1687 18.3065" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  ),
});
